import script from "./ProfileSettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSettingPage.vue?vue&type=script&setup=true&lang=js"

import "./ProfileSettingPage.vue?vue&type=style&index=0&id=2ebbb525&lang=css"

const __exports__ = script;

export default __exports__